import BaseItem, { Rarity } from './base_item';

export default class CargoScanner extends BaseItem {
    constructor(x, y) {
        super(x, y, "items", "cargo_scanner.png");
    }

    //this is width/height of collision box (attached to bottom)
    static get width() { return 27;}
    static get height() { return 12;}

    static get mass() { return 5;}
    static get electronic() { return true; }
    static get rarity() { return Rarity.COMMON; }

    static get type() { return 'cargo_scanner'}
    static get label() { return 'cargo scanner'}
    static get description() { return `It's a cargo scanner. Works on magic and unhealthy dose of x-rays.`}
}


// WEBPACK FOOTER //
// ./src/objects/items/cargo_scanner.js